import React, { useState, useMemo, useEffect, useCallback } from "react"
import { useDispatch } from "react-redux"
import axios, { GenericAbortSignal } from "axios"
import { finishMounted } from "../../stores/transition"
import { Store as StoreType } from "../../components/stores/types"
import LinkButton from "../../components/LinkButton"
import { Link } from "../../components/Link"
import { StoreList } from "../../components/stores/StoreList"
import * as s from "./StoreListPage.module.scss"

type FetchParams = {
  signal: GenericAbortSignal
}

export default function StoreListPage() {
  const dispatch = useDispatch()
  const [isMounted, setIsMounted] = useState(false)
  const [stores, setStores] = useState<StoreType[]>([])

  const fetch = useCallback(async (params: FetchParams) => {
    const url = new URL(`/${window.gon.locale}/api/stores`, location.origin);
    const res = await axios.get(url.toString(), { signal: params.signal })
    const stores = res.data.data
    setStores(
      stores.map((store)=> ({...store.attributes, id: store.id}))
    )
  }, [])

  useEffect(() => {
    const controller = new AbortController()

    fetch({ signal: controller.signal })
      .then(() => setIsMounted(true))

    return ()=> controller.abort()

  }, [])

  if(isMounted) dispatch(finishMounted())

  return <div className="container">
    <h3 className={`h3 text-center ${s.heading}`}>取扱店一覧（五十音順）</h3>
    <p className={`text-center ${s.lead}`}>
      お取り扱い頂ける酒販店様募集中です。<Link to="/inquiry">Contact</Link>よりお問い合わせください。
    </p>
    <StoreList items={stores} />
    <LinkButton to="/" className={`w-100 ${s.backButton}`}>戻る</LinkButton>
  </div>

}
